import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const HyunDaiMarineEngine = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const handleTransProducts = (productName : string) => {
        navigate(`/hyundai/marineEngine/${productName}`)
    }
    return(
        <>
        <div className="contentBox">
            <ul>
                <li onClick={()=>handleTransProducts('hd403')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd403.png" alt="HD403 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_1")}</span>
                        <span>70PS ~ 150PS / 3,298~3,907cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProducts('hd404')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd404.png" alt="HD404 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_2")}</span>
                        <span>175PS / 3,933cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProducts('hd608')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd608.png" alt="HD608 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_3")}</span>
                        <span>250PS / 5,899cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProducts('hd611')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd611.png" alt="HD611 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_4")}</span>
                        <span>260PS ~ 330PS / 11,149cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProducts('hd614')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd614.png" alt="HD614 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_5")}</span>
                        <span>410PS / 9,960cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProducts('hd612')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd612.png" alt="HD612 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_6")}</span>
                        <span>470PS ~ 500PS / 12,344cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProducts('hd615')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hd615.png" alt="HD615 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>{t("hyundai_7")}</span>
                        <span>550PS ~ 600PS / 12,742cc</span>
                    </div>
                </li>
            </ul>
        </div>
        </>
    )
}